<template>
  <div class="quiz" id="quiz" data-toggle="buttons">
    <b-row>
      <b-col lg="6" v-for="item in answers" :key="item">
        <b-button
          :variant="variant"
          @click="answer()"
          class="element-animation1 btn-block answer"
          pill
        >
            {{ item.answer }}</b-button
        ></b-col
      >
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    answers:[],
  },
  data() {
    return {
      variant: "outline-dark",
    };
  },
};
</script>

<style>
</style>